<div class="r-content-outer-container">
  <div class="container r-content-inner-container">
    <app-header></app-header>
  </div>

  <div class="r-main-container">
    <mat-sidenav-container>
      <mat-sidenav #sidenav [mode]="mode" role="navigation" opened>
        <mat-card appearance="outlined">
          <mat-card-content>
            <app-menu></app-menu>
          </mat-card-content>
        </mat-card>
      </mat-sidenav>

      <mat-sidenav-content class="full-height">
        <app-information-banner></app-information-banner>
        <mat-card appearance="outlined">
          <mat-card-content>
            <router-outlet></router-outlet>
          </mat-card-content>
        </mat-card>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>

  <div class="container r-footer-container">
    <app-footer></app-footer>
  </div>
</div>
